import { baseURL } from './config';

class GetSecrets {
    static async getloggingkey() {
        try {
            const apiUrl = `${baseURL}/api/config/logging-key`;
            const response = await fetch(apiUrl, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) {
                console.error(`Status: ${response.status}`);
                throw new Error('Failed to fetch logging key');
            }
            const data = await response.json();
            return data.key;
        } catch (error) {
            console.error('Error fetching logging key:', error);
            return null;
        }
    }
}

export { GetSecrets };
